/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { RadioGroup } from '@headlessui/react'
import { trackEvent } from 'analytics/trackFunctions'
import { Checkbox } from '../Checkbox'

interface AdvanceOptionCard {
  value: string
  badge: JSX.Element
  title: string
  disabled?: boolean
  description?: string
}

const AdvanceOptionCard = ({
  value,
  badge,
  title,
  disabled = false,
  description = null
}: AdvanceOptionCard) => (
  <RadioGroup.Option
    disabled={disabled}
    className='focus:outline-none'
    value={value}
  >
    {({ checked }) => (
      <li
        className={`transition-all h-16 cursor-pointer relative duration-300 ease-in-out bg-white w-full p-3 my-2 rounded-lg border border-gray-500 flex justify-center items-center focus:outline-none ${
          !!checked && 'ring-2 border-green-800 ring-green-800'
        } ${!!disabled && '!bg-gray-300 !text-gray-900'}`}
        // onClick={() => {
        //   trackEvent({
        //     eventName: `nuevo_renov_oferta_click_${installment.installments_quantity}_cuotas`
        //   })
        // }}
      >
        <Checkbox disabled={disabled} checked={checked} className='mr-4' />
        <div
          className={`flex-grow text-left text-xs ${
            checked ? 'text-[#08724C]' : 'text-black'
          }`}
        >
          <p className='font-bold'>{title}</p>
          {description ? (
            <p className='text-2xs text-gray-900 font-medium'>{description}</p>
          ) : null}
        </div>
        {badge}
      </li>
    )}
  </RadioGroup.Option>
)

export default AdvanceOptionCard
